import { TabProps, TabType } from '@types';

const Tabs = ({
  type = TabType.DEFAULT,
  tabs,
  onTabSelect,
  selectedTab,
  className
}: TabProps) => {
  const getStyle = (tabId: number) => {
    const defaultStyles =
      'table-cell truncate px-2 sm:px-4 py-1 text-center text-xs desktop:text-base font-semibold tablet:text-base';
    if (type === TabType.DEFAULT) {
      if (selectedTab?.id === tabId) return `${defaultStyles} text-primary`;
      return `${defaultStyles} text-grey10`;
    }
    if (type === TabType.CHIP) {
      if (selectedTab?.id === tabId)
        return `${defaultStyles} rounded-xl mobile:rounded-lg bg-warning text-theme`;
      return `${defaultStyles} rounded-xl mobile:rounded-lg border border-warning text-warning`;
    }
    return defaultStyles;
  };

  return (
    <div
      className={`flex ${
        type === TabType.DEFAULT
          ? 'border-b-2 border-grey40'
          : 'flex flex-wrap items-center justify-start gap-2 sm:gap-3'
      } ${className || ''}`}
    >
      {tabs?.map((tab) => (
        <div
          role="presentation"
          className="min-w-180 flex cursor-pointer flex-col"
          key={tab.id}
          onClick={() => {
            onTabSelect?.(tab);
          }}
        >
          <div className={getStyle(tab.id)} key={tab.id}>
            {tab.label} {typeof tab?.count === 'number' && `(${tab?.count})`}
          </div>
          {type === TabType.DEFAULT && (
            <div
              className={`relative top-0.5 border-b-4 border-primary ${
                selectedTab?.id !== tab.id && 'invisible'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
